import pipeline from '@/pipeline';

export enum Provider {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple',
  DESCOMPLICA = 'descomplica',
}

export enum ProductName {
  UNDERGRAD_DESCOMPLICA = 'undergrad',
}

export enum SignTabs {
  SignIn = 'signin',
  SignUp = 'signup',
}

export enum AccountsPages {
  SIGN_IN = 'entrar',
  SIGN_UP = 'cadastrar',
  COMPLETE_SIGN_UP = 'cadastro-completo',
  COMPLETE_REGISTRATION = 'completar-perfil',
}

export enum SignMethods {
  SIGN_IN = 'sign_in',
  SIGN_UP = 'sign_up',
  COMPLETED_PROFILE = 'completed_profile',
}

export interface LoginWithIframeData {
  url: any;
  email?: string;
  phone?: string;
  hideTabs?: SignTabs[];
  hideSocialButtons?: Provider[];
  productName?: ProductName;
  hideSocialMedia?: boolean;
  hideHeaders?: boolean;
  hideFooter?: boolean;
  hidePassword?: boolean;
  disableEmail?: boolean;
  disablePhone?: boolean;
  onSuccess?: () => void;
  onError?: () => void;
}

export interface ProfilePocket extends ProfileResultExtra {
  id: number | string;
  name: string;
  email: string;
  d: string;
  extra?: ProfileResultExtra;
}

export interface ProfileResult extends ProfileResultExtra {
  id: number;
  name: string;
  email: string;
  d: string;
  extra?: ProfileResultExtra;
}

export interface ProfileResultExtra {
  d?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  signMethod?: SignMethods;
}

export interface Profile {
  (): ProfileResult;
  logout: () => void;
  reset: () => void;
  getCookie: () => ProfilePocket;
}

const goToNextPipeline = (): void => {
  pipeline.next();
};

const loginWithIframe = (
  params: LoginWithIframeData,
  elementToEmbedIn: string,
  classToAdd: string,
) => {
  if (window.POCKET) {
    window.POCKET.Auth.loginWithIframe({
      onSuccess: goToNextPipeline,
      ...params,
    });

    const authIframeContainer = document.querySelector('.authIframeContainer');
    const content = document.querySelector(elementToEmbedIn);

    if (content && authIframeContainer) {
      authIframeContainer.classList.add(classToAdd);
      content.appendChild(authIframeContainer);
    }
  }
};

const getPocketProfile = (): ProfileResult | undefined => {
  if (window.POCKET) {
    const user = window.POCKET.profile();
    const userByCookie = window.POCKET.profile.getCookie();

    if (!user && !userByCookie) return;

    // FIXME: work-around
    const signMethods = [userByCookie?.signMethod, user?.signMethod];
    // eslint-disable-next-line no-nested-ternary
    const signMethod = signMethods.includes(SignMethods.COMPLETED_PROFILE)
      ? SignMethods.COMPLETED_PROFILE
      : signMethods.includes(SignMethods.SIGN_UP)
      ? SignMethods.SIGN_UP
      : user.signMethod;

    const result = { ...userByCookie?.extra, ...user?.extra, ...user, ...userByCookie, signMethod };

    const idValidations = typeof result.id === 'string' ? +result.id : result.id;

    return { ...result, id: idValidations };
  }
};

const getTokenD = (): string | undefined => {
  const profile = getPocketProfile();
  return profile?.d;
};

const getEmailByPocket = (): string | undefined => {
  const profile = window.POCKET.profile();
  return profile?.email;
};

const getProfileName = (): string | undefined => {
  const profile = getPocketProfile();
  return profile?.name;
};

const isLogged = (): boolean => {
  if (!window.POCKET) {
    return false;
  }

  return !!getTokenD();
};

const logout = (): boolean => {
  if (!window.POCKET) {
    return false;
  }

  window.POCKET.profile.logout();

  return !isLogged();
};

export default {
  loginWithIframe,
  getPocketProfile,
  isLogged,
  logout,
  getTokenD,
  getEmailByPocket,
  getProfileName,
  goToNextPipeline,
};
